module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-mobile@2x-166bd67e2250cea3a1c40d646e0645c2.webp";